<template>
    <div class="relative mx-0 mt-10 mb-2">
        <div class="bg-black lg:bg-transparent slider">
            <swiper ref="slider" :options="swiperOptions">
                <swiper-slide class="flex items-center justify-center" v-for="item in items" :key="`slider-item_${item.image}`">
                    <img class="w-full" :src="item.image" />
                    <div class="absolute w-full py-5 pl-20 pr-20 text-white bg-black bg-opacity-50 lg:py-20 md:pl-20 lg:pl-40">
                        <div class="text-lg md:text-2xl lg:text-3xl">
                            {{ item.alternativeText }}
                        </div>
                        <EpiLink v-if="item.imageLink"
                                    :url="item.imageLink"
                                    :title="`Les mer om ${item.alternativeText}`"
                                    class="inline-block mt-4 btn btn-xs md:btn-sm btn-green md:mt-6">
                            <img v-if="item.buttonIcon" :src="item.buttonIcon" class="inline-block w-10 h-10 -my-2 align-middle" />
                            <span class="inline-block align-middle">{{item.buttonText}} &rarr;</span>
                        </EpiLink>
                    </div>
                </swiper-slide>
                <div v-if="items.length > 1" class="hidden text-gray-600 border border-gray-400 rounded-full swiper-button swiper-button-prev md:flexp-6 opacity-90 hover:opacity-100 hover:border-gray-600 hover:bg-white bg-gray-50 hover:text-gray-900" slot="button-prev"></div>
                <div v-if="items.length > 1" class="hidden p-6 text-gray-600 border border-gray-400 rounded-full swiper-button swiper-button-next md:flex opacity-90 hover:opacity-100 hover:border-gray-600 hover:bg-white bg-gray-50 hover:text-gray-900" slot="button-next"></div>
            </swiper>
        </div>
        <div
            v-if="items.length > 1"
            class="relative pb-4 swiper-pagination"
            slot="pagination"
        />
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';

export default {
    props: ['items'],
    components: {
        Swiper,
        SwiperSlide,
        EpiLink
    },
    data() {
        return {
            swiperOptions: {
                loop: this.items.length > 1,
                centeredSlides: true,
                effect: 'slide',
                autoHeight: false,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            }
        };
    },
    computed: {
        swiper() {
            return this.$refs.slider.$swiper;
        }
    }
};
</script>
